import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cc from 'classcat';

import { template } from '../../lib/template';
import { removeToast } from '../../store/toasts/actions';
import Container from '../Container';

import styles from './styles.module.scss';

// This must be the same as what is in the animation open and close classes.
const ANIMATION_DURATION = 1000;

class Toast extends Component {
  static defaultProps = {
    status: 'ok',
    duration: 5000,
  };
  state = {
    closing: false,
  };

  static propTypes = {
    id: PropTypes.string,
    message: PropTypes.string,
    variables: PropTypes.object,
    status: PropTypes.oneOf(['ok', 'error', 'warning']),
  };

  componentDidMount() {
    this._timer = setTimeout(this._onClose, this.props.duration);
  }

  componentWillUnmount() {
    clearTimeout(this._timer);
    this._timer = undefined;
  }

  _onClose = () => {
    const { onClose, removeToast, id } = this.props;

    clearTimeout(this._timer);
    this._timer = undefined;
    this.setState({ closing: true });
    setTimeout(() => removeToast(id), ANIMATION_DURATION);

    if (onClose) {
      // wait for the leave animation to finish
      setTimeout(onClose, ANIMATION_DURATION);
    }
  };

  render() {
    const { message, status, variables } = this.props;
    const { closing } = this.state;
    const classNames = cc([
      styles.container,
      styles[status],
      {
        [styles.closing]: closing,
      },
    ]);
    const content = template(message, variables);

    return (
      <div className={classNames}>
        <Container className={styles.inner} role="alert">
          {content}
        </Container>
      </div>
    );
  }
}

export default connect(null, { removeToast })(Toast);
